import { ApiPrefix } from '@/constants/constants';
import { useAccount } from '@/store/account';
import { Session } from '@/utils/storage';

export const getRefererAppId = (appid?: string) => {
	let _appid = appid || useAccount().appId;
	if (_appid === 'sub_invoice') {
		// 外部用户是直接登录子系统的走的saas的登录，但是没有refererAppid
		if (useAccount().account?.accountType === '2') {
			_appid = 'main_saas';
		}else {
			// 企业用户是直接登录子系统，但是没有refererAppid,默认走main_group，后期需要后端调整判断具体平台
			_appid = Session.get('refererAppId') || 'main_group';
		}
	}
	return _appid;
};

/**
 * 根据不同平台返回不同api前缀
 * @param appid
 * @returns
 */
export const genETaxLoginApiPrefix = (appid?: string) => {
	return getRefererAppId(appid) === 'main_group' ? ApiPrefix.GroupDefault : ApiPrefix.QyApiDefault;
};

/**
 * 根据不同平台返回不同任务类型key
 * @param appid
 * @returns
 */
export const genRwlxKey = (appid?: string) => {
	return getRefererAppId(appid) === 'main_group' ? 'ptywlx' : 'rwlx';
};
